<template>
  <div id="tableContainerBody">
        <div id="tableContainer">

  <v-card class="headerBody">
     <img style="margin-left:10px" id="logo" alt="Main Logo" src="../assets/Revlon-logo.svg" />
     <p style="font-weight:bold; color: #109cf1">Reset password</p>
    <div v-if="error" class="inputs" style="color:red">{{error}}</div>
     <div v-if="success"  style="text-align: center; margin:50px">
      <img src="../assets/comprobar.svg">
      <p style="margin:50px">We have sent a link to your email address to reset your password</p>
        <span class="psw"><a v-on:click="goToLogin()" style="color: #000000;" href="#">Go back to login</a></span>
    </div>
    <form v-if="!success" action="#" @submit.prevent="submit">
      <v-text-field required v-model="form.email" class="inputs" id="email" name="name" label="Email" hide-details="auto"></v-text-field>
      <v-btn v-on:click="resetPassword()" id="formBodyTitle">Send reset email</v-btn>
      <br>
          <span class="psw"><a v-on:click="goToLogin()" style="color: #000000;" href="#">Go back to login</a></span>
    </form>
  </v-card>
        </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import router from '../router';

  export default {
    data () {
      return {
        search: '',
        form: {
          name: "",
          email: "",
        },
        success: false,
        error: null
      };
    },
    beforeMount() {
      firebase.auth().signOut()
    },
    methods: {
      resetPassword() {
        if(this.form.email != ""){
          var that = this;
          firebase.auth().sendPasswordResetEmail(this.form.email).then(function() {
            that.success = true
          }).catch(function(error) {
            console.log(error)
          });
        } else {
          alert("Please enter an email to recover password")
        }
      }
      ,goToLogin() {
        router.replace({
          name: "Login"
        });
      }
    },
  }
</script>

<style scoped>
#logo {
  margin-bottom: 100px !important;
  margin-top: 80px !important;
  width: 500px;
  height: 150px;
  object-fit: contain;
}
.headerButtonBottom {
  width: 40%;
  height: 3px;
  margin-top: 10px;
  background-color: white;
}
.headerBody {
  display: inline-block;
  justify-content: center;
  align-items: center;
  align-content: center;

  width: 576px;
  height: 896px;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(43, 45, 55, 0.01);
  background-color: #ffffff;
}

#formBodyTitle {
  margin-top: 50px;
  font-size: 16px;
  background-color: #109cf1;;
  color: #ffffff;
  font-weight: 500;
  margin-bottom: 32px;
  width: 80%;
  height: 40px;
}

.inputs {
  margin-left: 55px !important;
  align-self: center;
  margin:30px;
  width: 80%;
}
#topContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 20px 20px;
}
#bodyTitle {
  text-align: left;
  font-weight: bold;
  margin-left: 30px;
  font-size: 16px;
  color: #191c23;
}
#chooseTableHeader {
  width: 100%;
  height: 60px;
  background-color: white;
  color: #767675;
  display: flex;
  justify-content: left;
  align-items: center;
}
#scheduledButton {
  margin-left: 20px;
  margin-right: 50px;
}
#tableContainer {
  height: 100%;
  width: 97%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#tableContainerBody {
  background-color: #f5f6f8;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 20px;
}
.filterButton {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.selected {
  color: #109cf1;
}
.selectedheaderButtonBottom {
  background-color: #109cf1;
}
.modal {
  width: 500px;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 3px;
  transition: all 0.2s ease-in;
}
.fadeIn-enter {
  opacity: 0;
}
.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}
.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}
</style>
